import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NO_AUTH_CONTEXT } from '@app/tokens';
import config from '@config';
import * as Sentry from '@sentry/angular';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly http = inject(HttpClient);
  private checkVersionPromise: Promise<boolean> | null = null;

  getEnvVersion(): string | undefined {
    return config.version;
  }

  async getApiVersion(): Promise<string | undefined> {
    try {
      const data = await firstValueFrom(this.http.get<{ version?: string }>('/public/app.json', { context: NO_AUTH_CONTEXT }));
      return data?.version;
    } catch {
      return undefined;
    }
  }

  checkVersion(onMismatch?: () => Promise<void>): Promise<boolean> {
    if (this.checkVersionPromise) return this.checkVersionPromise;
    this.checkVersionPromise = this.doCheckVersion(onMismatch).finally(() => {
      this.checkVersionPromise = null;
    });
    return this.checkVersionPromise;
  }

  private async doCheckVersion(onMismatch?: () => Promise<void>): Promise<boolean> {
    const apiVersion = await this.getApiVersion();
    const envVersion = this.getEnvVersion();
    console.debug('Checking app version', { apiVersion, envVersion });

    if (!apiVersion) {
      console.warn('API version not found');
      Sentry.captureMessage('API version not found', 'warning');
    } else if (!envVersion) {
      console.warn('ENV version not found');
      Sentry.captureMessage('ENV version not found', 'warning');
    } else if (apiVersion !== envVersion) {
      console.log('Version different! Refreshing...', { apiVersion, envVersion });
      await onMismatch?.();
      window.location.reload();
    }

    return true;
  }
}
